import React, { useEffect, useRef } from 'react';
import { background } from '../../profile';

const ParticlesBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');

        let animFrame;
        let particles = [];

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resize();
        window.addEventListener('resize', resize);

        if (background.type === 'Snow') {
            for (let i = 0; i < 75; i += 1) {
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    r: Math.random() * 4 + 2,
                    speed: Math.random() * 1.5 + 0.5,
                    wind: Math.random() * 0.4 - 0.2,
                });
            }

            const draw = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = 'rgba(0,0,0,0.55)';
                particles.forEach(p => {
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                    ctx.fill();
                    p.y += p.speed;
                    p.x += p.wind;
                    if (p.y > canvas.height) {
                        p.y = -p.r;
                        p.x = Math.random() * canvas.width;
                    }
                });
                animFrame = requestAnimationFrame(draw);
            };
            draw();
        } else {
            // Particle network (default) — connected dots with lines
            const count = Math.min(120, Math.floor((canvas.width * canvas.height) / 14000));
            for (let i = 0; i < count; i += 1) {
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    vx: (Math.random() - 0.5) * 0.6,
                    vy: (Math.random() - 0.5) * 0.6,
                    r: Math.random() * 2 + 1,
                });
            }

            const linkDist = 140;

            const draw = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // Update + draw nodes
                particles.forEach(p => {
                    p.x += p.vx;
                    p.y += p.vy;
                    if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
                    if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                    ctx.fillStyle = 'rgba(120,120,120,0.85)';
                    ctx.fill();
                });

                // Draw links
                for (let i = 0; i < particles.length; i += 1) {
                    for (let j = i + 1; j < particles.length; j += 1) {
                        const dx = particles[i].x - particles[j].x;
                        const dy = particles[i].y - particles[j].y;
                        const dist = Math.sqrt(dx * dx + dy * dy);
                        if (dist < linkDist) {
                            const alpha = 1 - dist / linkDist;
                            ctx.strokeStyle = `rgba(120,120,120,${alpha * 0.5})`;
                            ctx.lineWidth = 1;
                            ctx.beginPath();
                            ctx.moveTo(particles[i].x, particles[i].y);
                            ctx.lineTo(particles[j].x, particles[j].y);
                            ctx.stroke();
                        }
                    }
                }

                animFrame = requestAnimationFrame(draw);
            };
            draw();
        }

        return () => {
            cancelAnimationFrame(animFrame);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                pointerEvents: 'none',
                zIndex: 0,
                margin: 0,
            }}
        />
    );
};

export default ParticlesBackground;
